import React from 'react';
import TopNavbar from '../../../home/TopNavbar';

const styles = `
    .container {
        max-width: 1200px;
        margin: auto;
        background-color: #fff;
        padding: 10px;
        border-radius: 10px;
        box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
        padding-bottom: 100px;
        margin-top: 30px;
    }

    /* Table Responsive Wrapper */
    .table-responsive-wrapper {
        width: 100%;
        overflow-x: auto; /* Enables horizontal scrolling */
        -webkit-overflow-scrolling: touch; /* Smooth scrolling for mobile */
        margin-top: 20px;
        border-radius: 8px;
    }

    /* Heading styles */
    .main-heading {
        padding-top: 50px;
        color: #004d40;
        text-align: center;
        font-size: 1.5em;
        margin-bottom: 10px;
        border-bottom: 3px solid #004d40;
        padding-bottom: 10px;
    }

    .sub-heading {
        color: #00695c;
        font-size: 2em;
        margin-top: 40px;
        margin-bottom: 15px;
    }

    /* Paragraph styles */
    .intro-paragraph, .section-paragraph {
        font-size: 1em;
        text-align: justify;
        margin-bottom: 20px;
    }

    /* Table styles */
    table {
        width: 100%;
        min-width: 700px; /* Forces scroll on small screens to keep columns readable */
        border-collapse: collapse;
        box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
    }

    th, td {
        padding: 12px;
        text-align: left;
        border: 1px solid #ddd;
    }

    thead th {
        background-color: #004d40;
        color: #fff;
        font-weight: bold;
        text-transform: uppercase;
        position: sticky; /* Optional: keeps header visible while scrolling vertically */
        top: 0;
    }

    /* Alternating row colors */
    tbody tr:nth-child(even) {
        background-color: #e8f5e9;
    }

    tbody tr:nth-child(odd) {
        background-color: #f0fdf2;
    }

    /* Hover effect */
    tbody tr:hover {
        background-color: #c8e6c9;
        transition: background-color 0.3s ease;
    }

    /* Styling for the total row */
    tbody tr:last-child {
        font-weight: bold;
        background-color: #b2dfdb !important;
    }

    tbody tr:last-child td {
        border-top: 2px solid #004d40;
    }

    /* Scrollbar styling for better UX */
    .table-responsive-wrapper::-webkit-scrollbar {
        height: 8px;
    }
    .table-responsive-wrapper::-webkit-scrollbar-thumb {
        background: #004d40;
        border-radius: 10px;
    }
    .table-responsive-wrapper::-webkit-scrollbar-track {
        background: #f1f1f1;
    }
`;

const BotanyData = [
    { chapter: "Anatomy of Flowering Plants", easy: 2, medium: 11, hard: 3, total: 16, average: 3.20, weightage: '6.23%' },
    { chapter: "Biodiversity and Conservation", easy: 9, medium: 2, hard: 1, total: 12, average: 2.40, weightage: '4.67%' },
    { chapter: "Biological Classification", easy: 2, medium: 5, hard: 0, total: 7, average: 1.40, weightage: '2.72%' },
    { chapter: "Cell : The Unit of Life", easy: 3, medium: 1, hard: 2, total: 6, average: 1.20, weightage: '2.33%' },
    { chapter: "Cell Cycle and Cell Division", easy: 10, medium: 10, hard: 3, total: 23, average: 4.60, weightage: '8.95%' },
    { chapter: "Ecosystem", easy: 4, medium: 4, hard: 2, total: 10, average: 2.00, weightage: '3.89%' },
    { chapter: "Environmental Issues", easy: 5, medium: 3, hard: 0, total: 8, average: 1.60, weightage: '3.11%' },
    { chapter: "Microbes in Human Welfare", easy: 2, medium: 1, hard: 2, total: 5, average: 1.00, weightage: '1.95%' },
    { chapter: "Mineral Nutrition", easy: 3, medium: 0, hard: 4, total: 7, average: 1.40, weightage: '2.72%' },
    { chapter: "Molecular Basis of Inheritance", easy: 16, medium: 15, hard: 3, total: 34, average: 6.80, weightage: '13.23%' },
    { chapter: "Morphology of Flowering Plants", easy: 7, medium: 7, hard: 3, total: 17, average: 3.40, weightage: '6.61%' },
    { chapter: "Organisms and Populations", easy: 5, medium: 3, hard: 4, total: 12, average: 2.40, weightage: '4.67%' },
    { chapter: "Photosynthesis in Higher Plants", easy: 5, medium: 7, hard: 0, total: 12, average: 2.40, weightage: '4.67%' },
    { chapter: "Plant Growth and Development", easy: 13, medium: 2, hard: 1, total: 16, average: 3.20, weightage: '6.23%' },
    { chapter: "Plant Kingdom", easy: 8, medium: 2, hard: 4, total: 14, average: 2.80, weightage: '5.45%' },
    { chapter: "Principles of Inheritance and Variation", easy: 8, medium: 10, hard: 5, total: 23, average: 4.60, weightage: '8.95%' },
    { chapter: "Respiration in Plants", easy: 3, medium: 3, hard: 2, total: 8, average: 1.60, weightage: '3.11%' },
    { chapter: "Sexual Reproduction in Flowering Plants", easy: 6, medium: 6, hard: 1, total: 13, average: 2.60, weightage: '5.06%' },
    { chapter: "Strategies for Enhancement in Food Production", easy: 1, medium: 1, hard: 0, total: 2, average: 0.40, weightage: '0.78%' },
    { chapter: "Transport in Plants", easy: 3, medium: 2, hard: 2, total: 7, average: 1.40, weightage: '2.72%' },
    { chapter: "The Living World", easy: 0, medium: 1, hard: 0, total: 1, average: 0.20, weightage: '0.39%' },
    { chapter: "Cell: The Unit of Life (Repeat)", easy: 1, medium: 1, hard: 2, total: 4, average: 0.80, weightage: '1.56%' },
];

const ZoologyData = [
    { chapter: "Animal Kingdom", easy: 10, medium: 13, hard: 3, total: 26, average: 5.20, weightage: '9.85%' },
    { chapter: "Biomolecules", easy: 8, medium: 13, hard: 6, total: 27, average: 5.40, weightage: '10.23%' },
    { chapter: "Biotechnology - Principles and Processes", easy: 11, medium: 14, hard: 6, total: 31, average: 6.20, weightage: '11.74%' },
    { chapter: "Biotechnology and its Applications", easy: 5, medium: 12, hard: 1, total: 18, average: 3.60, weightage: '6.82%' },
    { chapter: "Body Fluids and Circulation", easy: 2, medium: 9, hard: 1, total: 12, average: 2.40, weightage: '4.55%' },
    { chapter: "Breathing and Exchange of Gases", easy: 2, medium: 7, hard: 1, total: 10, average: 2.00, weightage: '3.79%' },
    { chapter: "Chemical Coordination and Integration", easy: 3, medium: 3, hard: 1, total: 7, average: 1.40, weightage: '2.65%' },
    { chapter: "Digestion and Absorption", easy: 6, medium: 4, hard: 0, total: 10, average: 2.00, weightage: '3.79%' },
    { chapter: "Evolution", easy: 5, medium: 8, hard: 2, total: 15, average: 3.00, weightage: '5.68%' },
    { chapter: "Excretory Products and their Elimination", easy: 3, medium: 5, hard: 3, total: 11, average: 2.20, weightage: '4.17%' },
    { chapter: "Human Health and Disease", easy: 3, medium: 11, hard: 2, total: 16, average: 3.20, weightage: '6.06%' },
    { chapter: "Human Reproduction", easy: 3, medium: 11, hard: 5, total: 19, average: 3.80, weightage: '7.20%' },
    { chapter: "Locomotion and Movement", easy: 1, medium: 12, hard: 2, total: 15, average: 3.00, weightage: '5.68%' },
    { chapter: "Neural Control and Coordination", easy: 0, medium: 4, hard: 2, total: 6, average: 1.20, weightage: '2.27%' },
    { chapter: "Reproductive Health", easy: 6, medium: 12, hard: 0, total: 18, average: 3.60, weightage: '6.82%' },
    { chapter: "Structural Organisation in Animals (Animal Tissues)", easy: 7, medium: 13, hard: 3, total: 23, average: 4.60, weightage: '8.71%' },
];

const renderTable = (data) => (
    <div className="table-responsive-wrapper">
        <table>
            <thead>
                <tr>
                    <th>Chapter Name</th>
                    <th>Easy</th>
                    <th>Medium</th>
                    <th>Hard</th>
                    <th>Total</th>
                    <th>Average Q/yr</th>
                    <th>Weightage</th>
                </tr>
            </thead>
            <tbody>
                {data.map((item, index) => (
                    <tr key={index}>
                        <td>{item.chapter}</td>
                        <td>{item.easy}</td>
                        <td>{item.medium}</td>
                        <td>{item.hard}</td>
                        <td>{item.total}</td>
                        <td>{item.average}</td>
                        <td>{item.weightage}</td>
                    </tr>
                ))}
                <tr>
                    <td><strong>Total</strong></td>
                    <td><strong>{data.reduce((sum, item) => sum + item.easy, 0)}</strong></td>
                    <td><strong>{data.reduce((sum, item) => sum + item.medium, 0)}</strong></td>
                    <td><strong>{data.reduce((sum, item) => sum + item.hard, 0)}</strong></td>
                    <td><strong>{data.reduce((sum, item) => sum + item.total, 0)}</strong></td>
                    <td><strong>{data.reduce((sum, item) => sum + item.average, 0).toFixed(2)}</strong></td>
                    <td><strong>100%</strong></td>
                </tr>
            </tbody>
        </table>
    </div>
);

const AllNeetWeightageBiology = () => {
    return (
        <div>
            <style>{styles}</style>
            <div className="container">
                <TopNavbar name="Biology Weightage" />
                <h1 className="main-heading">NEET 5-Year Biology Question Analysis (2020-2024)</h1>
                <p className="intro-paragraph">
                    This comprehensive analysis provides a detailed breakdown of question distribution and difficulty levels for the NEET Biology section from 2020 to 2024.
                </p>

                <h2 className="sub-heading">Botany Question Analysis</h2>
                <p className="section-paragraph">
                    Scroll left or right on the table below to view all data points including average questions per year and weightage.
                </p>
                {renderTable(BotanyData)}

                <h2 className="sub-heading">Zoology Question Analysis</h2>
                <p className="section-paragraph">
                    Detailed analysis of Zoology chapters across easy, medium, and hard difficulty levels.
                </p>
                {renderTable(ZoologyData)}
            </div>
        </div>
    );
};

export default AllNeetWeightageBiology;